import { render, staticRenderFns } from "./RoleSelect.vue?vue&type=template&id=74e87d5a"
import script from "./RoleSelect.vue?vue&type=script&lang=ts"
export * from "./RoleSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.11.0_webpack@5.109.2__ejs@3.1.10_hand_b7975ec27586492790fee85183072e80/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports